export default function Viewmodel$release () {
	return this.captureGroups.pop();
}
